import { primaryColors } from "../../assets/styles/helpers/colors.styles";
export const checkIconStyles = {
  width: "1rem",
  height: "1rem",
  color: primaryColors.black,
};
